import StartData from '@/models/StartDataModel';
const proxy = process.env.VUE_APP_API_URL ?? '';
import Respondent from '@/models/RespondentModel';
import Message from '@/models/MessageModel';
import RequiredInputsPayload from '@/models/RequiredInputsPayloadModel';

const TRANSLATIONS_GROUP = 'script_texts';

interface WebbbotRespondentPayload {
	fp: string;
	start_survey: boolean;
	is_iframe: boolean;
	survey_id: number;
	widget_id: string | number;
	analytic_cookies: {
		facebook_events: string;
		google_analytics: string;
		yandex_metrika: string;
	};
	ua: string;
	parent_url: string;
}

interface WebbotRespondentData {
	chat_id: string;
	messages: Array<Message>;
	respondent: Respondent;
}

export default {
	async getStartData(surveyId: string, query: string): Promise<StartData> {
		const response = await fetch(
			`${proxy}/api/surveys/${surveyId}/start-data?${query ?? ''}`
		);
		return await response.json();
	},

	async webbotRespondent(
		projectId: number | string,
		data: WebbbotRespondentPayload
	): Promise<WebbotRespondentData> {
		const response = await fetch(
			`${proxy}/api/projects/${projectId}/get-webbot-respondent`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			}
		);

		return await response.json();
	},

	async sendRequiredInputs(respondentId: number, data: RequiredInputsPayload) {
		await fetch(`${proxy}/api/v2/respondents/${respondentId}`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		});
	},

	async uploadFile(data: FormData) {
		const response = await fetch(`${proxy}/api/v2/attachments/webbot`, {
			method: 'POST',
			body: data
		});
		return await response.json();
	},

	async sendRespondentDisconnected(projectId: number | string, respondentId: number) {
		const response = await fetch(
			`${proxy}/api/projects/${projectId}/respondents/${respondentId}/offline`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			}
		);

		return await response.json();
	},

	async loadTranslations(locale: string) {
		const response = await fetch(
			`${proxy}/api/v2/translations/${TRANSLATIONS_GROUP}/${locale}`
		);
		return await response.json();
	}
};
